import React, {useEffect, useState} from 'react';
import SideBar from "../../../../../common/SideBar";
import NavBar from "../../../../../common/NavBar";
import {Link, useHistory} from "react-router-dom";
import {makeStyles} from '@material-ui/core/styles';
import InputMask from "react-input-mask";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Spinner from "reactjs-simple-spinner";
import ClaimsService from "../../../../../services/ClaimsService";
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import FilesService from "../../../../../services/FilesService";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 250,
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));




const EditInothoAccident = (props) => {

    let history = useHistory();
    const classes = useStyles();


    const [loading, setLoading] = useState(false);

    const [policyNumber, setPolicyNumber] = useState(null);
    const [claimReason, setClaimReason] = useState(null);
    const [amountClaimed, setAmountClaimed] = useState(0);
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');
    const [files, setFiles] = useState({});
    const [uploadLoading1, setUploadLoading1] = useState(false);

    const [accountName, setAccountName] = useState(null);
    const [bank, setBank] = useState(null);
    const [accountNumber, setAccountNumber] = useState(null);
    const [branch, setBranch] = useState(null);
    const [walletName, setWalletName] = useState(null);
    const [mobileNumber, setMobileNumber] = useState(null);
    const [mobileAccountNumber, setMobileAccountNumber] = useState(null);
    const [file, setFile] = useState(0);

    const [payoutMethod, setPayoutMethod] = useState(false)
    const [showBankDetails, setShowBankDetails] = useState(false);
    const [showMobileDetails, setShowMobileDetails] = useState(false);
    const [claim, setClaim] = useState({})
    const [postalAddress, setPostalAddress] = useState(null);
    const [descriptionAccident, setDescriptionAccident] = useState(null);
    const [dateOfInjury, setDateOfInjury] = useState(null);


    const handleChange = name => ({target: {value}}) => {
        if (name === 'policyNumber') {
            setPolicyNumber(value);
        }
        if (name === 'claimReason') {
            setClaimReason(value);
        }
        if (name === 'descriptionAccident') {
            setDescriptionAccident(value)
        }
        if (name === 'dateOfInjury') {
            setDateOfInjury(value)
        }
        if (name === 'cashPayOutMethod' && value === 'true') {
            setShowBankDetails(false);
            setShowMobileDetails(true);
            setPayoutMethod(value)
        }
        if (name === 'amountClaimed') {
            setAmountClaimed(value);
        }
        if (name === 'cashPayOutMethod' && value === 'false') {
            setShowMobileDetails(false);
            setShowBankDetails(true);
            setPayoutMethod(value)
        }
        if (name === 'accountName') {
            setAccountName(value)
        }
        if (name === 'bank') {
            setBank(value)
        }
        if (name === 'branch') {
            setBranch(value)
        }
        if (name === 'accountNumber') {
            setAccountNumber(value)
        }
        if (name === 'walletName') {
            setWalletName(value)
        }
        if (name === 'mobileNumber') {
            setMobileNumber(value)
        }
        if (name === 'mobileAccountNumber') {
            setMobileAccountNumber(value)
        }
        if (name === 'postalAddress') {
            setPostalAddress(value)
        }
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(true)

        setShowBankDetails(false);
        setShowMobileDetails(false);
        setMessage('');
        setShow(false)
        let token = JSON.parse(localStorage.getItem('token'));
        let c = JSON.parse(localStorage.getItem('claim'));
        console.log("token", token)
        console.log("claim", c)
        setClaim(c)
        setFile(c.file)
        setPostalAddress(c.postal_address)
        setBranch(c.account_branch)
        setBank(c.bank)
        setAccountNumber(c.account_number)
        setAccountName(c.account_name)
        setMobileNumber(c.mobile_number)
        setMobileAccountNumber(c.mobile_account_number)
        setWalletName(c.wallet_name)
        setAmountClaimed(c.amount_claimed)
        setClaimReason(c.claim_reason)
        setDateOfInjury(c.date_of_injury)
        setDescriptionAccident(c.accident_description)
        setLoading(false)

    }, []);


    const handleSave = (e) => {
        e.preventDefault();

        setLoading(true);

        if (bank === null) {
            setBank('none')
        }
        if (branch === null) {
            setBranch('none')
        }
        if (accountName === null) {
            setAccountName('none')
        }
        if (accountNumber === null) {
            setAccountNumber('none')
        }
        if (mobileNumber === null) {
            setMobileNumber('0000000000')
        }
        if (mobileAccountNumber === null) {
            setMobileAccountNumber('none')
        }
        if (walletName === null) {
            setWalletName('none')
        }

        let data = {
            "id": claim.id,
            "policy_number": claim.policy_number,
            "id_number": claim.id_number,
            "first_name_of_assured": claim.first_name,
            "last_name_of_assured": claim.last_name,
            "email": claim.email,
            "postal_address": postalAddress,
            "amount_claimed": amountClaimed,
            "inception_date": claim.inception_date,
            "claim_reason": claimReason,
            "bank": bank,
            "account_branch": branch,
            "account_number": accountNumber,
            "account_name": accountName,
            "wallet_name": walletName,
            "mobile_number": mobileNumber,
            "mobile_account_number": mobileAccountNumber,
            "cash_payout": JSON.parse(payoutMethod),
            "date_of_injury": dateOfInjury,
            "accident_description": descriptionAccident,
            'file': file

        }

        console.log(data)

        ClaimsService.updateClaim(data)
            .then(res => {
                console.log(res.status)
                if (res.status === 201 || res.status === 200) {
                    setShow(false);
                    toast.success('Claim Updated Successfully', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);
                    // history.push('/claims');
                } else if (res.status === 400) {
                    toast.warning('Wrong inputs!! Please check your details', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);

                } else {
                    console.log("error: " + res.response.data.message);
                    setLoading(false);
                    toast.warning(res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                    });
                }

            })
            .catch(err => {
                setLoading(false)
                toast.warning('Operation Failed, Error: ' + err.response.data.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log(err);
            });
    }

    const handleFileChange1 = (e) => {
        setUploadLoading1(true);
        console.log(e);
        const file = e.target.files[0];
        let name = e.target.name
        const formData = new FormData();
        formData.append("file", file);
        formData.append('policy_number', claim.policy_number)
        FilesService.savingsWithdrawalUpload(formData)
            .then(res => {
                console.log(res);

                ClaimsService.updateClaimFile({
                    "id": claim.id, 'file': 1
                })
                    .then(response => {
                        console.log("response:- ", response)
                        if (response.status === 200) {
                            toast.success('Claim file updated successfully', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            console.log(e.target.name)
                            setMessage('Successful');
                            setFiles({...files, [name]: name})
                            setFile(1)
                            setUploadLoading1(false);
                        } else {
                            toast.warning('Claim file not updated', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                            setUploadLoading1(false);
                        }
                    }).catch(error => {
                    console.log("error:- ", error)
                    toast.warning('Claim file not updated', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setMessage('')
                    setUploadLoading1(false);
                })

            })
            .catch(err => {
                console.log(err);
                setMessage('');
                toast.warning('Upload Failed', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUploadLoading1(false);
            });
    }

    const [downloading, setDownloading] = useState(false);
    //download file
    const downloadFile = () => {
        setDownloading(true);
        console.log("id", claim.id)
        let id = parseInt(claim.id);
        FilesService.savingsWithdrawalDownload(id)
            .then(res => {
                console.log("res", res);
                if (res.status === 200) {
                    toast.success('Download Successful', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setDownloading(false);
                } else {
                    console.log("res", res);
                    toast.warning('Download Failed', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setDownloading(false);
                }

            }).catch((err) => {
            setDownloading(false);
            toast.warning('Download Failed', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log("err", err);
        })
    }


    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/claims"><a href><i className="fa-solid fa-basket-shopping"/>&nbsp;Claims</a>
                            </Link>
                             &nbsp;|&nbsp;
                            <Link to="/pfuma-claims"><a href><i className="fa-solid fa-cow"/>&nbsp;Pfuma
                                Claims</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/inotho-accident"><a href><i
                                className="fa-solid fa-money-bill-transfer"/>&nbsp;Inotho Personal Accident Claims</a>
                            </Link>
                             &nbsp;|&nbsp;
                            <span className="upper-class">Update Inotho Personal Accident Claim</span>
                        </ul>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="medium"
                                                message="Please wait,Good things takes time....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>

                                    )}
                                    {!loading && (
                                        <form id="policyholderData" onSubmit={handleSave} autoComplete="off">
                                            <div id="form-style">
                                                <h4 className="text-primary font-weight-bold text-center">Update
                                                    Claim</h4>
                                                <div className="row mt">
                                                    <div className="col-md-10 container border border-gray p-4">
                                                        <div className={classes.root}>
                                                            <div>
                                                                <div className="row">
                                                                    <div className="form-group col-md-3">
                                                                        <label>
                                                                            <span className="text-danger">*</span>Claimant
                                                                            FirstName</label>
                                                                        <input
                                                                            type="text"
                                                                            autoComplete="off"
                                                                            value={claim.first_name_of_assured}
                                                                            disabled={true}
                                                                                className="form-control"
                                                                                name="claimantFirstName"
                                                                                onChange={handleChange('claimantFirstName')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("firstname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Claimant
                                                                                LastName</label>
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                value={claim.last_name_of_assured}
                                                                                disabled={true}
                                                                                className="form-control"
                                                                                name="claimantLastName"
                                                                                onChange={handleChange('claimantLastName')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("firstname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>ID
                                                                                Number
                                                                            </label>
                                                                            <InputMask mask='99999999**99'
                                                                                       className="form-control"
                                                                                       maskChar=" "
                                                                                       value={claim.id_number}
                                                                                       disabled={true}
                                                                                       required
                                                                                       name="claimantIdNumber"
                                                                                       onChange={handleChange('claimantIdNumber')}
                                                                            />

                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Email</label>
                                                                            <input
                                                                                type="email"
                                                                                autoComplete="off"
                                                                                className="form-control"
                                                                                name="claimantEmail"
                                                                                value={claim.email}
                                                                                disabled={true}
                                                                                onChange={handleChange('claimantEmail')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("firstname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="form-row">

                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Inception
                                                                                Date</label>
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                className="form-control"
                                                                                name="inceptionDate"
                                                                                value={claim.inception_date}
                                                                                disabled={true}
                                                                                onChange={handleChange('inceptionDate')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("lastname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Amount
                                                                                Claimed</label>

<input
                                                                                type="number"
readOnly={claim.claim_status === 'PAID'}
                                                                                autoComplete="off"
                                                                                className="form-control"
                                                                                name="amountClaimed"
                                                                                value={amountClaimed}
                                                                                onChange={handleChange('amountClaimed')}
                                                                            />
                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("firstname") }}*/}
                                                                            </p>
                                                                        </div>
                                                                        <div className="form-group col-md-3">
                                                                            <label> <span
                                                                                className="text-danger">*</span>Date of
                                                                                Injury</label>
                                                                            <input
                                                                                type="text"
                                                                                autoComplete="off"
                                                                                className="form-control"
                                                                                name="dateOfInjury"
                                                                                value={dateOfInjury}
                                                                                onChange={handleChange('dateOfInjury')}
                                                                            />

                                                                            <p className="message">
                                                                                {/*{{ validation.firstError("dateOfBirth") }}*/}
                                                                            </p>
                                                                        </div>

                                                                    </div>
                                                                    <div className="row mt-4 mb-4">
                                                                        <div className="col-md-12">
                                                                            <label htmlFor=""> <span
                                                                                className="text-danger">*</span>Accident
                                                                                Description</label>
                                                                            <textarea
                                                                                onChange={handleChange('descriptionAccident')}
                                                                                className="form-control"
                                                                                value={descriptionAccident}
                                                                                rows="6"
                                                                                placeholder="Enter Description Of Accident">
                            </textarea>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                <div>
                                                                    <div className="row mt-3">
                                                                        <h5 className="text-primary font-weight-bold">Financial
                                                                            Details</h5>
                                                                    </div>
                                                                    <div className="row">

                                                                        <div className="form-group mb-3 col-md-6">
                                                                            <label>
                                                                                <strong>CASH PAYOUT </strong>
                                                                            </label>
                                                                            <select name="cashPayOutMethod" id=""
                                                                                    className="form-control"
                                                                                    onChange={handleChange('cashPayOutMethod')}>

                                                                                <option value={true} selected={claim.cash_payout == 1 ? true : false}>Yes</option>
                                                                                <option value={false} selected={claim.cash_payout == 0 ? true : false}>No</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    {claim.cash_payout == 0 && (
                                                                        <div className="row">

                                                                            <div className="form-group col-md-12">
                                                                                <label>
                                                                                    <strong>BANK PAYOUT</strong>
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label>Account Name</label>
                                                                                <input
                                                                                    type="tel"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="accountName"
                                                                                    readOnly={true}
                                                                                    value={accountName}
                                                                                    onChange={handleChange('accountName')}
                                                                                />
                                                                                <p className="message">
                                                                                    {/*{{ validation.firstError("lastname") }}*/}
                                                                                </p>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label>Bank Name</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="bank"
                                                                                    readOnly={true}
                                                                                    value={bank}
                                                                                    onChange={handleChange('bank')}
                                                                                />
                                                                                <p className="message">
                                                                                    {/*{{ validation.firstError("firstname") }}*/}
                                                                                </p>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label>Account Number</label>
                                                                                <input
                                                                                    type="tel"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="accountNumber"
                                                                                    readOnly={true}
                                                                                    value={accountNumber}
                                                                                    onChange={handleChange('accountNumber')}
                                                                                />
                                                                                <p className="message">
                                                                                    {/*{{ validation.firstError("lastname") }}*/}
                                                                                </p>
                                                                            </div>

                                                                            <div className="form-group col-md-3">
                                                                                <label>Branch</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="branch"
                                                                                    readOnly={true}
                                                                                    value={branch}
                                                                                    onChange={handleChange('branch')}
                                                                                />
                                                                                <p className="message">
                                                                                    {/*{{ validation.firstError("firstname") }}*/}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {claim.cash_payout == 1 && (
                                                                        <div className="mb-3 form-row">
                                                                            <div className="form-group col-md-12">
                                                                                <label>
                                                                                    <strong>MOBILE PAYOUT</strong>
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-group col-md-4">
                                                                                <label>Wallet Name</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="mobileNumber"
                                                                                    readOnly={true}
                                                                                    value={claim.wallet_name}
                                                                                    onChange={handleChange('mobileNumber')}
                                                                                />
                                                                            </div>

                                                                            <div className="form-group col-md-4">
                                                                                <label>Mobile Number</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="mobileNumber"
                                                                                    readOnly={true}
                                                                                    value={mobileNumber}
                                                                                    onChange={handleChange('mobileNumber')}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group col-md-4">
                                                                                <label>Mobile Account Number</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    readOnly={true}
                                                                                    name="mobileAccountNumber"
                                                                                    value={mobileNumber}
                                                                                    onChange={handleChange('mobileAccountNumber')}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {showBankDetails && (
                                                                        <div className="row">

                                                                            <div className="form-group col-md-12">
                                                                                <label>
                                                                                    <strong>BANK PAYOUT</strong>
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label>Account Name</label>
                                                                                <input
                                                                                    type="tel"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="accountName"
                                                                                    value={accountName}
                                                                                    onChange={handleChange('accountName')}
                                                                                />
                                                                                <p className="message">
                                                                                    {/*{{ validation.firstError("lastname") }}*/}
                                                                                </p>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label>Bank Name</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="bank"
                                                                                    value={bank}
                                                                                    onChange={handleChange('bank')}
                                                                                />
                                                                                <p className="message">
                                                                                    {/*{{ validation.firstError("firstname") }}*/}
                                                                                </p>
                                                                            </div>
                                                                            <div className="form-group col-md-3">
                                                                                <label>Account Number</label>
                                                                                <input
                                                                                    type="tel"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="accountNumber"
                                                                                    value={accountNumber}
                                                                                    onChange={handleChange('accountNumber')}
                                                                                />
                                                                                <p className="message">
                                                                                    {/*{{ validation.firstError("lastname") }}*/}
                                                                                </p>
                                                                            </div>

                                                                            <div className="form-group col-md-3">
                                                                                <label>Branch</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="branch"
                                                                                    value={branch}
                                                                                    onChange={handleChange('branch')}
                                                                                />
                                                                                <p className="message">
                                                                                    {/*{{ validation.firstError("firstname") }}*/}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {showMobileDetails && (
                                                                        <div className="mb-3 form-row">
                                                                            <div className="form-group col-md-12">
                                                                                <label>
                                                                                    <strong>MOBILE PAYOUT</strong>
                                                                                </label>
                                                                            </div>
                                                                            <div className="form-group col-md-4">
                                                                                <label>Wallet Name</label>
                                                                                <select name="walletName" id=""
                                                                                        className="form-control"
                                                                                        onChange={handleChange('walletName')}>
                                                                                    <option value={claim.wallet_name} selected>
                                                                                        {claim.wallet_name}
                                                                                    </option>
                                                                                    <option
                                                                                        value="ECOCASH">ECOCASH
                                                                                    </option>
                                                                                    <option
                                                                                        value="TELECASH">TELECASH
                                                                                    </option>
                                                                                    <option value="ONE_WALLET">ONE
                                                                                        WALLET
                                                                                    </option>
                                                                                </select>
                                                                            </div>

                                                                            <div className="form-group col-md-4">
                                                                                <label>Mobile Number</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="mobileNumber"
                                                                                    value={mobileNumber}
                                                                                    onChange={handleChange('mobileNumber')}
                                                                                />
                                                                            </div>
                                                                            <div className="form-group col-md-4">
                                                                                <label>Mobile Account Number</label>
                                                                                <input
                                                                                    type="text"
                                                                                    autoComplete="off"
                                                                                    className="form-control"
                                                                                    name="mobileAccountNumber"
                                                                                    value={mobileNumber}
                                                                                    onChange={handleChange('mobileAccountNumber')}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                    <hr/>
                                                                    <div className="form-row">
                                                                        <div className="form-group col-md-12">
                                                                            <label>
                                                                                <strong>POSTAL ADDRESS</strong>
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-group col-md-6">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="street"
                                                                                value={postalAddress}
                                                                                autoComplete="off"
                                                                                onChange={handleChange('postalAddress')}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr/>
                                                                <div>
                                                                    <div className="row mt-3">
                                                                        <h5 className="text-primary font-weight-bold">Documents</h5>
                                                                    </div>
                                                                    <div className="row mb-4">
                                                                        <div className="col-md-6">
                                                                            {/*    download button*/}
                                                                            {downloading && (
                                                                                <span className="mt-2 mb-2 p-2">
                                        <Spinner
                                            size="medium"
                                            message="Downloading file....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </span>
                                                                            )}
                                                                            {!downloading && (
                                                                                <>
                                                                                    {claim.file === 0 || claim.file === "0" ? (
                                                                                        <div className="row mb-4">
                                                                                            <div className="col-md-6">
                                                                                                <span
                                                                                                    className="text-success">
                                                                                                    <br/>
                                                                                                    No File Uploaded &nbsp;
                                                                                                    <i className="fa-regular fa-ban"></i>
                                                                                    </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="row">
                                                                                            <div className="col-md-3">
                                                                                                <button
                                                                                                    onClick={downloadFile}
                                                                                                    className="btn btn-sm btn-success">Download
                                                                                                    Claim
                                                                                                    Files&nbsp;<i
                                                                                                        className="fa-solid fa-download"></i>
                                                                                                </button>
                                                                                            </div>

                                                                                        </div>
                                                                                    )}

                                                                                </>
                                                                            )}
                                                                        </div>
                                                                        <div className="col-md-6">

                                                                            <div className="row mb-3">
                                                                                {uploadLoading1 && (
                                                                                    <span className="mt-2 mb-2 p-2">
                                        <Spinner
                                            size="medium"
                                            message="Uploading File....."
                                            line-fg-color="#64c3c2"
                                        />
                                    </span>
                                                                                )}
                                                                                {message !== '' && !uploadLoading1 && (
                                                                                    <span className="text-success">
                                        <br/>File Saved&nbsp;<i className="fa fa-check"/>
                                    </span>
                                                                                )}
                                                                                {message === '' && !uploadLoading1 && (
                                                                                    <div className="col-md-6 mb-2">

                                                                                        <label htmlFor="inputEmail4">Update
                                                                                            Client Document</label>
                                                                                        <br/>
                                                                                        <label
                                                                                            className="text-muted text-sm-center">*
                                                                                            Select File</label>
                                                                                        &nbsp;&nbsp;
                                                                                        {/*<span style={{display: "none"}} id="uploadingLoader"/>*/}

                                                                                        <div>
                                                                                            {message === '' && !uploadLoading1 && (
                                                                                                <label
                                                                                                    className="btn btn-sm btn-primary"
                                                                                                    htmlFor="my-file-selector">
                                                                                                    <input
                                                                                                        id="my-file-selector"
                                                                                                        type="file"
                                                                                                        name="claimantCertificate"
                                                                                                        style={{display: "none"}}
                                                                                                        accept=".pdf, .docx, .doc"
                                                                                                        onChange={handleFileChange1}
                                                                                                    />
                                                                                                    <i className="fa fa-folder-open"/>&nbsp;&nbsp;
                                                                                                    Browse
                                                                                                </label>
                                                                                            )}
                                                                                            <div className="p-3"/>
                                                                                        </div>
                                                                                    </div>
                                                                                )}


                                                                            </div>


                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                <div className="row">
                                                                    <button className="btn btn-sm btn-primary"
                                                                            onClick={handleSave}>
                                                                        <i className="fa-solid fa-paper-plane"></i>&nbsp;
                                                                        Submit Claim Details
                                                                    </button>
                                                                </div>
                                                            </div>

                                                        </div>

                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditInothoAccident;
